import { render, staticRenderFns } from "./SecurityConformance.vue?vue&type=template&id=27826ca1&scoped=true&"
import script from "./SecurityConformance.vue?vue&type=script&lang=js&"
export * from "./SecurityConformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27826ca1",
  null
  
)

export default component.exports